"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEPLOYMENT_SITE_CODES = exports.DEPLOYMENT_SITE_LECOFFREIO = void 0;
exports.normalizeLegacyDeploymentSiteCode = normalizeLegacyDeploymentSiteCode;
exports.isDeploymentSiteCode = isDeploymentSiteCode;
exports.sanitizeDeploymentSiteSlug = sanitizeDeploymentSiteSlug;
exports.nestedSecretsDirForDeploymentSiteCode = nestedSecretsDirForDeploymentSiteCode;
exports.DEPLOYMENT_SITE_LECOFFREIO = "lecoffreio";
exports.DEPLOYMENT_SITE_CODES = [exports.DEPLOYMENT_SITE_LECOFFREIO];
function normalizeLegacyDeploymentSiteCode(siteCode) {
    return siteCode.trim().toLowerCase();
}
function isDeploymentSiteCode(value) {
    const n = normalizeLegacyDeploymentSiteCode(value);
    return exports.DEPLOYMENT_SITE_CODES.includes(n);
}
function sanitizeDeploymentSiteSlug(raw) {
    const n = normalizeLegacyDeploymentSiteCode(raw).replace(/[^a-z0-9-]/g, "");
    const trimmed = n.replace(/^-+|-+$/g, "");
    if (trimmed.length === 0) {
        return exports.DEPLOYMENT_SITE_LECOFFREIO;
    }
    if (!exports.DEPLOYMENT_SITE_CODES.includes(trimmed)) {
        throw new Error(`Invalid deployment site slug: ${raw} (expected lecoffreio; kogus is orchestrator-only, not a site line).`);
    }
    return trimmed;
}
function nestedSecretsDirForDeploymentSiteCode(deploymentCode) {
    const code = normalizeLegacyDeploymentSiteCode(deploymentCode);
    if (code === exports.DEPLOYMENT_SITE_LECOFFREIO)
        return "lecoffreio";
    throw new Error(`Invalid deployment site partition: ${deploymentCode} (expected lecoffreio). kogus is not a site slug.`);
}
